
import React, { Component } from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Sidebar from "components/Sidebar/Sidebar";

import routes from "routes.js";

function Admin() {
  const [color, setColor] = React.useState("black");
  const [sidebarOpen, setSidebarOpen] = React.useState(window.innerWidth > 991);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 991);
  const location = useLocation();
  const mainPanel = React.useRef(null);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  React.useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile && !sidebarOpen) {
        setSidebarOpen(true);
      } else if (mobile && sidebarOpen) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarOpen]);
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.path}
            element={<prop.component />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }, [location]);
  return (
    <>
      <div className="wrapper">
        <Sidebar 
          color={color} 
          image="" 
          routes={routes} 
          isOpen={sidebarOpen}
          className={sidebarOpen && isMobile ? 'show' : ''}
          onClose={() => setSidebarOpen(false)}
        />
        {isMobile && sidebarOpen && (
          <div 
            className="sidebar-overlay show" 
            onClick={() => setSidebarOpen(false)}
          />
        )}
        <div className={`main-panel ${!sidebarOpen ? 'sidebar-closed' : ''}`} ref={mainPanel}>
          <AdminNavbar onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
          <div className="content">
            <Routes>
              {getRoutes(routes)}
              <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default Admin;
